import React, {useState, createContext, useEffect} from 'react';
import {useQuery} from '@apollo/client'
import QUERY_USER from "./Queries/User";

export const WooUserContext = createContext();

export const WooUserProvider = ({children}) => {
    const userData = useQuery(QUERY_USER);
    const [wishlist, setWishlist] = useState([]);
    const store = {
        userData,
        wishlistState: [wishlist, setWishlist],
    };
    useEffect(() => {
        if (userData && userData.data && userData.data.viewer != null && userData.data.viewer.acfUserData.wishlist) {
            setWishlist(JSON.parse(userData.data.viewer.acfUserData.wishlist));
        }
    }, [userData, setWishlist]);
    return (
        <WooUserContext.Provider value={store}>
            {children}
        </WooUserContext.Provider>
    );
};

